import { isTimeInBrowserSettings, ServiceLocation } from '../helpers';

interface TimeZoneState {
  timeZoneTextInfo: string;
  currentTimeZone: string;
}

export const timeZoneHelper = (
  location: ServiceLocation,
  t: (a: string) => string,
  appConfig: typeof CSS_CONFIG,
): TimeZoneState => {
  const multipleTimeZones = appConfig.MULTIPLETIMEZONES;
  const localTimeZone = isTimeInBrowserSettings(location, appConfig)
    ? new Date()
        .toString()
        .replace(/^.*GMT.*\(/, '')
        .replace(/\)$/, '')
    : '';

  const localTimeZoneAbbreviation =
    localTimeZone.indexOf(' ') >= 0 &&
    isTimeInBrowserSettings(location, appConfig)
      ? localTimeZone
          .split(' ')
          .map((item) => item[0])
          .join('')
      : '';

  const timeZoneAbbr = localTimeZoneAbbreviation
    ? `(${localTimeZoneAbbreviation})`
    : '';

  const timeZoneTextInfo =
    multipleTimeZones && isTimeInBrowserSettings(location, appConfig)
      ? `${t(
          'components.timePicker.showingTimeZone',
        )} ${localTimeZone} ${timeZoneAbbr}`
      : '';

  const currentTimeZone = multipleTimeZones
    ? localTimeZoneAbbreviation || localTimeZone
    : '';

  return {
    timeZoneTextInfo,
    currentTimeZone,
  };
};
